import fr from 'facet-rest';
import BaseOverride from '../../../BaseOverride';

export default fr.metaOverride({ base: BaseOverride }).nameOverride('options', {
  _transformValue: () => (value, values, resource) => {
    const metaField = resource.meta().field('options');
    const noneOpt = metaField.options().list().find(opt => opt.attr('prompt') === 'None');

    if (noneOpt && value === noneOpt.id()) {
      // Remove all other items from the list
      return values.filter(item => item === noneOpt.id());
    }

    if (noneOpt && value !== noneOpt.id()) {
      // Remove the None selection
      return values.filter(item => item !== noneOpt.id());
    }
    return values;
  },
});
